import { FC } from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
import relativeTime from 'dayjs/plugin/relativeTime';

import StarRating from '@z-components/atoms/StarRating';

import styles from './ClientReviewCard.module.scss';

dayjs.extend(relativeTime);

// eslint-disable-next-line no-magic-numbers
const THIRTY_ONE_DAYS_IN_MS = 31 * 24 * 60 * 60 * 1000;

interface Props {
  locale?: string;
  message: string;
  rating: number;
  time: number;
  title?: string;
}

const ClientReviewCard: FC<Props> = ({
  locale = 'ja',
  message = '',
  rating = 0,
  time = 0,
  title = '',
}) => {
  const formattedTime =
    new Date().getTime() - time > THIRTY_ONE_DAYS_IN_MS
      ? dayjs(time).locale(locale).format('YYYY/MM')
      : dayjs(time).locale(locale).fromNow();

  return (
    <article className={styles.review}>
      {title && <h4>{title}</h4>}
      <div className={styles['rating-row']}>
        <StarRating displayNumber={true} height={14} rating={rating} />
        <p className={styles.time}>{formattedTime}</p>
      </div>

      <p className={styles.message}>{message}</p>
    </article>
  );
};

export type { Props as ClientReviewCardProps };
export default ClientReviewCard;
